import { useEffect } from "react";
import { AlertCircle } from "lucide-react";
import SpinnerButton from "@/components/SpinnerButton";

export default function ConfirmDialog({
    open,
    title,
    message,
    confirmLabel = "Confirm",
    cancelLabel = "Cancel",
    variant = "danger",
    loading = false,
    onConfirm,
    onCancel,
    testId,
    confirmTestId,
}) {
    useEffect(() => {
        if (!open) return undefined;
        const onKey = (e) => {
            if (e.key === "Escape") onCancel?.();
        };
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    }, [open, onCancel]);

    if (!open) return null;
    return (
        <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm"
            data-testid={testId || "confirm-dialog"}
            onClick={onCancel}
        >
            <div
                className="bg-ux-bg-1 border border-ux-border-1 rounded-lg shadow-xl w-full max-w-md p-5"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="flex items-start gap-3">
                    <AlertCircle className="w-5 h-5 text-ux-warning flex-shrink-0 mt-0.5" />
                    <div className="flex-1">
                        <h3 className="text-[15px] font-semibold text-ux-text-1">{title}</h3>
                        <p className="text-[13px] text-ux-text-2 mt-1">{message}</p>
                    </div>
                </div>
                <div className="mt-5 flex justify-end gap-2">
                    <SpinnerButton variant="secondary" onClick={onCancel} testId="confirm-dialog-cancel">
                        {cancelLabel}
                    </SpinnerButton>
                    <SpinnerButton
                        variant={variant}
                        loading={loading}
                        onClick={onConfirm}
                        testId={confirmTestId || "confirm-dialog-confirm"}
                    >
                        {confirmLabel}
                    </SpinnerButton>
                </div>
            </div>
        </div>
    );
}
